(() => {
  const label = '立即購買';
  const selector = '.shopify-payment-button__button--unbranded';

  const translateButtons = (root = document) => {
    root.querySelectorAll(selector).forEach((button) => {
      if (button.textContent.trim() !== label) {
        button.textContent = label;
      }
      button.setAttribute('aria-label', label);
    });
  };

  if (window.HaruHausBuyNowLabelLoaded) {
    translateButtons();
    return;
  }

  window.HaruHausBuyNowLabelLoaded = true;

  const observer = new MutationObserver(() => translateButtons());
  observer.observe(document.documentElement, { childList: true, subtree: true });

  translateButtons();
  document.addEventListener('shopify:section:load', (event) => translateButtons(event.target));
})();
